<!--
  - MyTh Ahmed Faiz Copyright © 2016-2022 All rights reserved.
  - Email: mythpe@gmail.com
  - Mobile: +966590470092
  - Website: https://www.4myth.com
  -->

<template>
  <app-card
    class="my-16"
    :title="$t('contactUs')"
  >
    <v-skeleton-loader
      v-if="skeleton"
      class="pa-2"
      type="article@2,text"
    />
    <ContactUsData v-else />
  </app-card>
</template>

<script>

import { MetaInfoMixin } from '@mixins'
import ContactUsData from '@components/landing/ContactUsData.vue'

export default {
  name: 'ContactUs',
  components: { ContactUsData },
  mixins: [MetaInfoMixin],
  data () {
    return {
      skeleton: !0
    }
  },
  mounted () {
    (async () => {
      await this.fetchAppSettings()
      this.skeleton = !1
    })()
  }
}
</script>
